import React from "react";
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
 const EmptyComponentRender = () => {
    const { t } = useTranslation();
    const customTheme = useTheme();
    return (
        <div style={{
            backgroundColor: customTheme.light.primary,
            borderRadius: 10,
            opacity: 0.7,
            padding: 15,
            marginBottom: 10,
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'center',
            justifyContent: 'center',
            alignContent: 'center'
        }}>
            <Typography>{t('general.empty')}</Typography>
        </div>
    );
}
export default EmptyComponentRender;